import job_search_0 from "file:///home/wldocker/wl-cms/sites/modules/job-search-widget/ui/src/job-search.js";job_search_0();